
import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import { getAllCookies, TOKEN, USER_ID } from 'Lib'

const Auth = {
	isAuthenticated: () => {
		const cookies = getAllCookies()

		let isAuth = false

		if (cookies && cookies[TOKEN] /*&& cookies[USER_ID]*/) {
			isAuth = true
		}

		return isAuth
	}
}

const PrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			return <Redirect to='/login' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const PublicRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			return <Redirect to='/' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return null
			}
		}
	}} />
}

export {
	PrivateRoute,
	PublicRoute,
	Auth,
}


// WEBPACK FOOTER //
// ./src/app/routes/routePermission.js